import script from "./WeightedTokenPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeightedTokenPill.vue?vue&type=script&setup=true&lang=ts"

import "./WeightedTokenPill.vue?vue&type=style&index=0&id=6b2f8875&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2f8875"]])

export default __exports__